import { render, staticRenderFns } from "./AllowCommentsToggle.vue?vue&type=template&id=a72dce40&scoped=true&"
import script from "./AllowCommentsToggle.vue?vue&type=script&lang=ts&"
export * from "./AllowCommentsToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72dce40",
  null
  
)

export default component.exports